import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#878E94" }) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 1V9V14C2 14.8 2.66667 15 3 15H12C12.8 15 13 14.3333 13 14V5H9C8.2 5 8 4.33333 8 4V0H3C2.2 0 2 0.666667 2 1Z"
        fill={fill}
      />
      <path d="M13 4L9 0V4H13Z" fill="#878E94" />
    </svg>
  );
};

export default memo(Icon);
